import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
// import tree from "../../assets/images/tree.png"
import {
  afterEffect,
  Illustrator,
  analytics,
  css,
  figma,
  golang,
  html,
  java,
  php,
  phtoshop,
  premier,
  react,
  swift,
  tagManager,
  samrus,
  insta,
  youtube,
  linkedin
} from "../../assets/newIcons";

type ServiceType = {
  name: string;
  description: string;
  icons: string[];
  path: string;
};

const services: ServiceType[] = [
    {
    name: "Personal Branding",
    description: "We help individuals build powerful personal brands that reflect their story, amplify their voice and create lasting trust across digital platforms.",
    icons: [linkedin,youtube, insta],
    path: "/personal-branding",
  },
  {
    name: "Designing",
    description:
      "Great designs create deeper brand recognition, build emotional connection and leave a lasting impression on every audience.",
    icons: [phtoshop, figma, Illustrator],
    path: "/branding-and-label",
  },

  {
    name: "Website & App Development",
    description:
      "Strong websites and apps deliver seamless experiences, drive user engagement and help brands grow consistently over time.",
    icons: [react, css, swift, html],
    path: "/web-app-development",
  },

  {
    name: "Software Development",
    description:
      "Custom software solutions simplify operations, increase efficiency and unlock faster growth opportunities for modern businesses.",
    icons: [java, golang, php],
    path: "/software-saas-development",
  },

  {
    name: "Marketing",
    description:
      "Smart marketing strategies connect genuinely with audiences, earn their trust and turn attention into loyal customer action.",
    icons: [samrus, analytics, tagManager],
    path: "/personal-branding",
  },
  {
    name: "Video Editing",
    description:
      "Powerful video editing transforms raw footage into polished stories that captivate viewers and strengthen brand presence online. ",
    icons: [premier, afterEffect],
    path: "/social-media-videos",
  },

];

const NewService = () => {
  const navigate = useNavigate();
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;
  return (
    <div
      className={`${
        theme === "dark" ? "bg-primary text-white" : "bg-black text-white"
      } relative overflow-hidden transition-all duration-500`}
    >
      <div className={`max-w-screen-2xl mx-auto px-5 lg:px-20 py-8 lg:py-28 relative`}>
        <h2 className="text-3xl bricolage-grotesque-bold px-5 sm:px-0 text-left mb-4 sm:mb-8 sm:text-5xl">
          Services
        </h2>
        <hr className="w-full border-1 border-white my-10" />
        <div className="grid grid-cols-1 lg:grid-cols-3 relative z-10 gap-10">
          {services.map((service, index) => (
            <div
              className={`${
                theme === "dark"
                  ? "bg-white hover:!shadow-[0px_0px_30px_#f20b97]"
                  : "card-gradient"
              }  p-[1px]  rounded-2xl cursor-pointer`}
              key={index}
              onClick={() => {
                navigate(service.path);
                  window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <div
                className={`${
                  theme === "dark" ? "bg-primary" : "bg-[#141414]"
                } py-6 px-4  h-full rounded-2xl flex flex-col justify-between hover:shadow-[inset_0px_0px_60px_#8D19DA] transition-all duration-500`}
              >
                <div className="">
                  <h4 className="font-gtAmerica font-semibold text-2xl mb-4 text-center sm:text-left">
                    {service.name}
                  </h4>
                  <p className="font-gtAmerica mb-4 text-center sm:text-left"> {service.description} </p>
                </div>
                <div className="flex gap-4 justify-center sm:justify-start">
                  {service.icons.map((icon) => (
                    <div
                      className={`${
                        theme === "dark" ? "bg-white" : "bg-black"
                      } size-14 flex justify-center items-center rounded-full border-secondary border-r border-t transition-all duration-500`}
                    >
                      <img src={icon} className="size-8" alt="" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* <img src={tree} className="absolute top-4 md:top-10 right-10 h-20 md:h-auto" alt="" /> */}
      </div>
      <svg
        width="1444"
        height="1292"
        viewBox="0 0 1444 1292"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute top-[250px] mx-auto left-0 right-0 w-full opacity-40"
      >
        <g filter="url(#filter0_f_3562_1617)">
          <ellipse cx="722" cy="646" rx="643" ry="393" fill="#8D19DA" />
        </g>
        <defs>
          <filter
            id="filter0_f_3562_1617"
            x="-173.6"
            y="0.399994"
            width="1791.2"
            height="1291.2"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="126.3"
              result="effect1_foregroundBlur_3562_1617"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default NewService;
